import { PropertyFiltersLocation } from '../../../services/properties/properties';
import { buildSerpURLObject } from '../links';
import { buildPageableSEO, DEFAULT_PAGEABLE, PageableOptions } from '../seo/seo';
import { template } from '../string/string';

interface SEOEntry {
  title: string,
  description: string,
}

export interface BuildPropertySerpSEOData {
  withArea: SEOEntry,
  withLocality: SEOEntry,
  withProvince: SEOEntry,
  common: SEOEntry,
}

export interface BuildPropertySerpSEOArgs {
  province?: PropertyFiltersLocation,
  locality?: PropertyFiltersLocation,
  area?: PropertyFiltersLocation,
  pageable: PageableOptions,
}

const PARAMS_FIELDS = ['province', 'locality', 'area'];
const FIELD_TO_DATA = {
  province: 'withProvince',
  locality: 'withLocality',
  area: 'withArea',
};

export function buildPropertySerpSEO(data: BuildPropertySerpSEOData, params: BuildPropertySerpSEOArgs = { pageable: DEFAULT_PAGEABLE }) {
  const { pageable } = params;
  const { common } = data;

  const rule = PARAMS_FIELDS.reduce((accumulator, key) => {
    if (params[key]) {
      return data[FIELD_TO_DATA[key]];
    }
    return accumulator;
  }, common);

  const result = template(
    rule,
    {
      province: params.province?.name,
      locality: params.locality?.name,
      area: params.area?.name,
    },
  );

  return buildPageableSEO(
    {
      ...result,
      urlObject: buildSerpURLObject({
        province: params.province?.slug,
        locality: params.locality?.slug,
        area: params.area?.slug,
      }),
    }, pageable,
  );
}

function buildH1Prefix(province?: PropertyFiltersLocation, locality?: PropertyFiltersLocation, area?: PropertyFiltersLocation) {
  if (province && province.name) {
    return `Provincia di ${province.name}`;
  }

  if (locality && locality.name) {
    return `${locality.name}${area && area.name ? ` ${area.name}` : ''}`;
  }

  return '';
}

export function buildSERPH1(province?: PropertyFiltersLocation, locality?: PropertyFiltersLocation, area?: PropertyFiltersLocation) {
  const prefix = buildH1Prefix(province, locality, area);

  return prefix ? `${prefix}: case e appartamenti in vendita` : 'Case e appartamenti in vendita';
}
